<template>
	<div id="appbox">
		<div class="top_heard">
				<div class="top_box">
					<div class="logo_box"  @click="gohome()">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<div class="top_gatebox">
						<div class="manage_switch" v-if="screenWidth>785">
							<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
							  <el-option
							    v-for="item in manageoptions"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value"
								>
							  </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="top_search_box">
						<!-- <div class="top_search">
							<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							  <el-option
							    v-for="item in options"
							    :key="item.value"
							    :label="item.label"
							    :value="item.value">
							  </el-option>
							</el-select>
							<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
							<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="getlist()" alt="" srcset="">
						</div> -->
					</div>
					<div class="top_right">
						<div class="top_Mobiletype"  @mouseover="showphonebox()" @mouseleave="closephonebox()"  >
							手机端
							<div class="Mobiletype_bubble" v-if="phoneboxshow" >
								<div class="copy-right">
									<img src="../../../static/img/suncode.jpg" />
								</div>
								<i class="el-icon-caret-top" ></i>
							</div>
						</div>
						<div class=""  @click="goregister()">
							注册
						</div>
					</div>
				</div>
				<div class="top_tab_box">
					<div class="toptabnav">
							<el-menu
							  :default-active="activeIndex2"
							  class="el-menu-demo"
							  mode="horizontal"
							  @select="handleSelect"
							  router
							  background-color="#1b9d57"
							  text-color="#FFFFFF"
							  active-text-color="#FFFFFF">
								<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
							<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
						</el-menu>
					</div>
				</div>
			</div>
		<div class="mapmenu_box">
			<div class="map_screen">
				<el-select v-model="region_type" size="medium" @change="camptypeschange" placeholder="选择区域">
					<el-option
					  v-for="item in regionlist"
					  :key="item.id"
					  :label="item.title"
					  :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="camptype"  size="medium"  @change="camptypeschange" placeholder="选择机构类型">
					<el-option
					  v-for="item in camptypes"
					  :key="item.value"
					  :label="item.label"
					  :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div >
			  <el-input placeholder="请输入内容" size="medium" v-model="search" class="input-with-select">
			    <el-button slot="append" @click="searchent" icon="el-icon-search">搜索</el-button>
			  </el-input>
			</div>
		</div>
		<div class="mapbox_main">
			<div class="map_box">
				<baidu-map class="bm-view" :center="positioning" :zoom="10" @ready="handler" :scroll-wheel-zoom="true">
					<!-- <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list> -->
					<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"  :autoLocation="true"></bm-geolocation>
					<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
				    <bm-marker v-if="maplist.length>0" v-for="(item,index) in maplist" :key="item" :position="{lng:item.longitude, lat: item.latitude}" :dragging="false" @click="infoWindowOpen(index)">
						<bm-label :content="item.title"  @click="infoWindowOpen(index)" :labelStyle="{color: '#67c23a', fontSize : '12px',border:'1px solid #67c23a',}" :offset="{width: -35, height: 30}"/>
				    </bm-marker>
					<bm-info-window v-if="maplist.length>0" :show="showinfowindow" :width="361" :closeOnClick="true" :position="{lng:openmap.longitude, lat: openmap.latitude}" :title="openmap.title" @clickclose="infoWindowClose(false)" :offset="{width: 0, height: -30}" >
						<div style="color:#333;font-size:16px;">
							   <div style="margin-top:5px;height: 2px; width:100%;background-color: #1b9d57 !important;"></div>
							   <div style="margin-top:5px;width:340px">  详细地址：{{ openmap.address }}</div>
							   <div style="margin-top:5px;width:340px">  联系方式：{{ openmap.phone }}</div>
							   <div style="margin-top:5px;height: 2px; width:100%;background-color: #1b9d57 !important;"></div>
								<div class="" style="margin-top:5px;width:340px;display: flex;justify-content: flex-end;">
									<el-button type="success" size="mini" plain round @click="detail(openmap.id)">进入详情</el-button>
								</div>
							<!-- <div style="margin-top:5px;width:220px">  指派人：{{ point.orderPeopleStr }}</div>
							   <div style="margin-top:5px;width:220px">  故障开始时间：{{ point.repairStartTime }}</div>
							   <div style="margin-top:5px;width:220px">  详细信息：{{ point.information }}</div> -->
						 </div>
					</bm-info-window>
				  </baidu-map>
			</div>
			<div class="mapcamp_list">
				<div class="mapcamp_list_title">
					<div class="list_title">
						<span v-if="region_type==''&&camptype==''&&search==''" >基地/营地列表</span><span v-else >符合条件的机构</span>(共计<span style="color: #1b9d57;">{{total}}</span>家)
					</div>
					<div class="list_tpis">
						可以点击基地/营地来将地图定位转移
					</div>
				</div>
				<ul class="infinite-list" v-infinite-scroll="putlist" style="overflow:auto">
				    <li  v-for="item in camplist" class="infinite-list-item" >
						<div class="mapcampitem"  @click="gocamplat(item.longitude,item.latitude)">
							<img :src="item.icon" alt="" srcset="">
							<div class="item_right">
								<div class="item_title">
									{{item.title}}
								</div>
								<div class="item_address">
									{{item.address}}
								</div>
							</div>
						</div>
					</li>
				  </ul>
			</div>
		</div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
	
</template>

<script>
	import {  getNewslist, getCategory, getCamplist, getPc, getMapcamp, getRegion,getbottomnav} from '@/request/api'
	
	export default {
	  name: "Campmap",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
				top_search_url:'',
				manage_url:'',
				manageoptions:[
					{
					  value: 'http://qianjin.wanjiaxiao.cn/',
					  label: '研学报备'
					}, {
					  value: 'https://admin.henanyanxue.com/',
					  label: '管理入口'
					},
					 
				],
				activeIndex2: '/Campmap',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				address:[
					{
					  value: 'Beijing',
					  label: '北京'
					}, {
					  value: 'Shanghai',
					  label: '上海'
					}, {
					  value: 'Nanjing',
					  label: '南京'
					}, {
					  value: 'Chengdu',
					  label: '成都'
					}, {
					  value: 'Shenzhen',
					  label: '深圳'
					}, {
					  value: 'Guangzhou',
					  label: '广州'
					}
				],
				logintype:true,
				banner:[
				],
				search: '',
				camptypes:[
					{ label: '全部', value: 0 },
					{ label: '基地', value: 2 },
					{ label: '营地', value: 1 },
				],
				camptype:'',
				positioning:{
					lng:113.752996,
					lat:34.765397, 
				},
				redlypositioning:{},
				camplist:[],
				  poiList:[{name:"全部地区", lng: 126.63, lat: 45.75},
        {name:"哈尔滨市", lng: 126.63, lat: 45.75},
{name:"齐齐哈尔市", lng: 123.97, lat: 47.33},
{name:"鹤岗市", lng: 130.3, lat: 47.33},
{name:"双鸭山市", lng: 131.17, lat: 46.65},
{name:"鸡西市", lng: 130.97, lat:45.3 },
{name:"大庆市", lng: 125.03, lat: 46.58},
{name:"伊春市", lng: 128.92, lat:47.73 },
{name:"绥化市", lng: 127, lat:46.63 },
{name:"黑河市", lng: 127.53, lat: 50.22},
{name:"牡丹江市", lng: 129.58, lat:44.6 },
{name:"佳木斯市", lng: 130.35, lat:46.83 },
{name:"七台河市", lng: 130.83, lat: 45.82},
{name:"大兴安岭", lng: 126.66, lat:45.74 }
        ],
				quicklist:[],
				maplist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				openmap:{},
				show: false,
				showinfowindow:false,
				regionlist:[],
				region_type:'',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Activitylist',
						text:'研学活动'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
					{
						link:'/traveler',
						text:'研学机构'
					},
					{
						link:'/mentorlist',
						text:'研学指导师'
					},
				],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		  this.getpcset()  
	  },
	  mounted() {
		   // const { id } = this.$route.query;
		      const { latitude,longitude } = this.$route.query;
			  if(latitude){
				  this.redlypositioning={
					lng:longitude,
					lat:latitude,
				  }
			  }
			   this.getbottomnav()
		   // this.uuid = id
		   this.getRegion()
			this.getlist()
	  },
	  methods: {
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		//this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		   handler ({BMap, map}) {
			   this.getMapcamp()
		        console.log('map',BMap, map)
				if(this.redlypositioning){
					this.positioning =  this.redlypositioning
				}
		        
		        // this.zoom = 15
		      },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  camptypeschange(){
			  console.log(this.camptype)
			   this.page_index=1
			  this.getMapcamp()
			  this.getlist()
			  for (const i in this.regionlist) {
				if (this.regionlist[i].id === this.region_type) {
					for (const k in this.poiList) {
						if (this.poiList[k].name == this.regionlist[i].title){
						this.$set(this, "positioning",{
						lng: this.poiList[k].lng,
						lat: this.poiList[k].lat
						} )
						}
					}
				}
			  }
		  },
		  searchent(){
			  // console.log(this.search)
			   this.page_index=1
			  this.getMapcamp()
			  this.getlist()
		  },
		  gocamplat(lng,lat){
			  this.positioning={
				  lng:lng,
				  lat:lat
			  }
		  },
		  getRegion(){
			var data={}
			getRegion(data).then(res=>{
				this.regionlist=res.data.data
			})
		  },
			getMapcamp(){
				var data={
					title:this.search,
					type:this.camptype,
					region_type:this.region_type,
				}
				getMapcamp(data).then(res=>{
					console.log(res)
				
					this.maplist=res.data.data
					this.openmap=res.data.data[0]
					const loading = this.$loading({
							 lock: true,
							text: '页面载入……',
							// spinner: 'el-icon-loading',
							background: '#ffffff'
						   });
					loading.close();
				})
			},
			infoWindowClose (index) {
				console.log('11111',index)
		        this.showinfowindow = index
				this.openmap={}
			},
			async infoWindowOpen (index) {
				this.showinfowindow = false
				 this.openmap=this.maplist[index]
				await console.log(this.openmap)
				this.showinfowindow = true
				// console.log(this.openmap,this.showinfowindow)
			},
			getpcset(){
				getPc().then(res=>{
					this.pcsetdata=res.data.data
					const loading = this.$loading({
							 lock: true,
							 text: 'Loading',
							 spinner: 'el-icon-loading',
							 background: 'rgba(0, 0, 0, 0.7)'
						   });
					loading.close();
				})  
			},
		  camptypetab(val){
			  this.region_type=val
			  this.page_index=1
			  this.getlist()
		  },
		  pagechange(val){
		  			  this.page_index=val
		  			   this.getlist()
		  },
		  getlist(){
			var data={
				page_index: this.page_index,
				page_size: 10,
				title:this.search,
				type:this.camptype,
				region_type:this.region_type,
			}  
			getCamplist(data).then(res=>{
				console.log(res.data)
				this.camplist=res.data.data.list
				this.total=res.data.data.total
			}).catch(error => {
				console.error(error);
			});
		  },
		  putlist(){
			var total=this.total/10
			if(total>this.page_index){
				this.page_index=this.page_index+1
				var data={
					page_index: this.page_index,
					page_size: 10,
				}  
				getCamplist(data).then(res=>{
					console.log(res.data)
					var list =  this.camplist
					for(var item of res.data.data.list){
						list.push(item)
					}
					this.camplist=list
					this.total=res.data.data.total
				}).catch(error => {
					console.error(error);
				});
			}
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
			  query: {
			  }
		    });
		  },
		  /*
		   * 查看详情
		   * */
		   
		  detail(e) {
		    this.$router.push({
		      path: "/CampDetails",
		      name: "CampDetails",
		      query: {
		        id: e
		      }
		    });
		  },
	  }
	};
</script>
<style>
	 .el-select .el-input {
	    width: 130px;
	  }
	  .input-with-select .el-input-group__prepend {
	    background-color: #fff;
	  }
	/*地图标题 infoWindow*/
	.BMap_bubble_title{
	  color:#1b9d57;
	  font-size:18px;
	  font-weight: 600;
	  /*font-weight: bold;*/
	  text-align:left;
	  background:transparent !important;
	}
	
	.BMap_pop .BMap_top{
	  background:#ffffff !important;
	  border:0 !important;
	}
	.BMap_pop .BMap_center{
	  /* width:251px !important; */
	  border:0 !important;
	  background:#ffffff !important;
	}
	.BMap_pop .BMap_bottom{
	  border:0 !important;
	  background:#ffffff !important;
	}
	
	.BMap_pop div:nth-child(3){
	  background:transparent !important;
	}
	.BMap_pop div:nth-child(3) div{
	  border-radius:7px;
	  background:#ffffff !important;
	  border:0 !important;
	}
	.BMap_pop div:nth-child(1){
	  border-radius:7px 0 0 0;
	  background:transparent !important;
	  border:0 !important;
	}
	.BMap_pop div:nth-child(1) div{
	  background:#ffffff !important;
	}
	.BMap_pop div:nth-child(5){
	  border-radius:0 0 0 7px;
	  background:transparent !important;
	  border:0 !important;
	}
	.BMap_pop div:nth-child(5) div{
	  border-radius:7px;
	  background:#ffffff !important;
	}
	.BMap_pop div:nth-child(7){
	  background:transparent !important;
	}
	.BMap_pop div:nth-child(7) div{
	  border-radius:7px;
	  background:#ffffff !important;
	}
	
	.BMap_pop div:nth-child(8) div{
	  /*border-radius:7px;*/
	  background:#ffffff !important;
	}
	/*窗体阴影*/
	.BMap_shadow div:nth-child(5) img{
	  /* margin-left: -1100px !important; */
	}
	
	.BMap_shadow div:nth-child(4){
	  width: 262px !important;
	}
	
	.BMap_Marker img{
		width: 39px !important;
	}
	
</style>
<style scoped>
	.map_screen{
		width: 280px;
		display: flex;
		justify-content: space-between;
		margin-right: 20px;
	}
	.mapmenu_box{
		width: calc(100% - 60px);
		padding:10px 30px;
		display: flex;
		justify-content:flex-start;
		align-items: center;
		background: #ffffff;
		    border-bottom: 1px solid #F2F6FC;
	}
	
	.mapbox_main{
		width: 100%;
		    display: flex;
		    justify-content: space-between;
		    min-height: 600px;
		    margin: 0px auto;
		    background: #ffffff;
	}
	.mapcamp_list_title{
		padding: 10px 0px;
			border-bottom: 1px dashed #DCDFE6;
	}
	.list_title{
		font-size: 20px;
		font-weight: 600;
	}
	.list_tpis{
		margin-top: 10px;
		font-size: 14px;
		color: #666666;
	}
	.main_box{
		width: 1500px;
		display: flex;
		justify-content: space-between;
		/* border-radius: 6px; */
		min-height: 600px;
		margin: 20px auto;
		
	}
	.map_box{
		/* width: 1000px; */
		flex:1;
		padding: 10px;
		background-color: #ffffff;
		/* box-shadow: 0 3px 3px rgba(0,200,169,.8); */
	}
	.mapcamp_list{
		width: 450px;
		padding: 10px;
		height: 800px;
		overflow-y: hidden !important;
		background-color: #ffffff;
		box-shadow: 0 3px 3px rgba(0,200,169,.8);
	}
	.infinite-list{
		/* width: 100%; */
		height:calc( 100% - 75px );
		list-style: none;
		overflow-y: auto;
		    padding-inline-start: 0px !important;
	}
	.infinite-list::-webkit-scrollbar{
		width: 0px;
		/* width: 100%; */
	}
	.infinite-list::-ms-scrollbar{
		width: 0px;
		/* width: 100%; */
	}
	.mapcampitem{
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding: 10px 0px;
		align-items: center;
		border-bottom: 1px dashed #DCDFE6;
		color: #333;
	}
	.mapcampitem:hover{
		color: #67c23a;
	}
	.mapcampitem img{
		width: 150px;
		height:71px ;
		
	}
	.item_right{
		    width: 290px;
		    height: 60px;
		    display: flex;
		    flex-direction: column;
		    justify-content: space-between;
		    padding-bottom: 10px;
	}
	.item_title{
		font-size: 16px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		font-weight: 600;
	}
	.item_address{
		/* margin-top: 10px; */
		font-size: 12px;
		text-align: left;
		color: #333;
		 overflow: hidden;
		 text-overflow: ellipsis;
		 white-space: nowrap;
		 width: 290px;
	}
	.bm-view {
	  width: 100%;
	  height: 800px;
	}
	.camplist{
		margin-top: 20px;
	}
	.campitems{
		margin-bottom: 20px;
		padding: 20px;
		background: #fff;
		transition: all .3s;
		-webkit-transition: all .3s;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.campitems:hover{
		box-shadow: 0 3px 20px rgba(0,200,169,.8);
	}
	.campitem_imgbox{
		position: relative;
		width: 337px;
		height: 161px;
		overflow: hidden;
	}
	.campitem_imgbox img{
		width: 100%;
		height: 100%;
	}
	.campitem_tags{
		position: absolute;
		    bottom: 0;
		    right: 0;
		    z-index: 1;
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
	}
	.campitem_tag{
		    height: 24px;
		    padding: 0 8px;
		    background: #1b9d57;
		    color: #fff;
		    line-height: 24px;
		    font-size: 12px;
			margin-left: 5px;
	}
	.campitem_msg{
		width: 750px;
		height: 161px;
		display: flex;
		flex-direction: column;
			margin-left: 10px;
		/* justify-content: ; */
		
	}
	.campitem_msg_title{
		color: #1b9d57;
		font-size: 18px;
		display: flex;
		align-items: center;
		padding: 0 10px 10px 0;
		border-bottom: 1px solid #e9e9e9;
		font-weight: 400;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		/* line-height: 24px; */
	}
	.campitem_msg_title span{
	/* 	    position: absolute;
		    top: 0;
		    left: 0; */
		    z-index: 1;
		    width: 60px;
		    height: 24px;
		    background: #1b9d57;
		    color: #fff;
		    font-size: 14px;
		    text-align: center;
			margin-right: 10px;
	}
	.campitem_msg_introduce{
		    height: 45px;
		    padding-top: 15px;
		    overflow: hidden;
			text-align: left;
			
	}
	.campitem_msg_button{
		height: 42px;
		    margin-top: 15px;
			display: flex;
			justify-content: flex-end;
	}
	.msg_button{
		    z-index: 1;
		    width: 134px;
		    height: 34px;
		    background: #1b9d57;
		    color: #fff;
		    line-height: 34px;
		    text-align: center;
		    border-radius: 4px;
	}
	
	.screen_box{
		margin-top: 30px;
		background: #fff;
		border: 1px solid #e9e9e9;
		border-bottom: 0;
		width: 100%;
		
	}
	.screen_items{
		width: 1100px;
		display: flex;
		flex-wrap: wrap;
		/* white-space: nowrap; */
		align-items: flex-start;
		/* overflow: scroll;   */
		overflow: auto;
		      white-space: nowrap;
		overflow-x: auto;
		overflow-y: hidden;
		
		/* padding-left: 134px; */
		
	
		border-bottom: 1px solid #e9e9e9;
		
	}
	.screen_title{
		width: 120px;
		padding: 19px 0;
		text-align: center;
		background: #f4f4f4;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}
	.screen_item{
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		    height: 34px;
		    line-height: 34px;
		text-align: center;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}
	.screen_item_a{
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		    height: 34px;
		    line-height: 34px;
		text-align: center;
		    background: #1b9d57;
		    color: #fff;
			flex-shrink: 0;
			flex-basis: auto;
			flex-grow: 0;
			display: inline-block;
			
	}
	.screen_item:hover{
		background: #1b9d57;
		color: #fff;
	}
	
</style>